<template>
  <BriefStep :title="title">
    <template v-slot:content>
      <div class="brief-form">
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="haveLogo"
            type="checkbox"
            name="haveLogo"
            v-model="form.haveLogo"
            @input="invokeTouch($v)"
            @change="updateValues"
          />
          <label for="haveLogo" class="form__label">posiadam logo</label>
        </div>
        <transition name="">
          <div
            v-if="form.haveLogo"
            class="brief-form__dropzone-wrapper"
            :class="{
              error: $v.form.logoImg.$anyError,
              add: showAddIcon,
              'brief-form__dropzone-wrapper--disabled': disableDropzone,
            }"
          >
            <vue2-dropzone
              id="logoDropzone"
              :options="dropzoneOptions"
              :useCustomSlot="true"
              ref="logoDropzone"
              @vdropzone-processing="disableDropzone = true"
              @vdropzone-file-added="logoUploaded"
              @vdropzone-removed-file="removedFile"
            >
              <p class="brief-form__dropzone-info">
                <img
                  data-uk-svg
                  src="@/assets/images/files-empty.svg"
                  alt="plik"
                />
                Jeśli posiadasz projekt logo pod ręką, upuść go tutaj lub
                kliknij i dodaj <Tooltip :title="uploadTooltip" />
              </p>
            </vue2-dropzone>
          </div>
        </transition>
        <div
          class="
            form__input-wrapper
            form__input-wrapper--check
            form__input-wrapper--check-squer
          "
        >
          <input
            class=""
            id="need"
            type="checkbox"
            name="needLogo"
            v-model="form.needLogo"
            @change="onNeedLogoChange"
          />
          <label for="need" class="form__label"
            >chcę ofertę na logo
            <Tooltip :title="tooltip" />
          </label>
        </div>
      </div>
    </template>
  </BriefStep>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import stepValidation from '../../mixins/stepValidation';

import BriefStep from '../global/BriefStep.vue';
import Tooltip from '../global/tooltip.vue';

export default {
  name: 'NeedLogo',
  components: { Tooltip, BriefStep, vue2Dropzone },
  mixins: [stepValidation],
  data: () => ({
    uploadTooltip:
      '(maks. 3 plik o wielkości 20MB w formacie jpg,png,svg lub pdf)',
    title:
      'Bez logo ani rusz! Posiadasz firmowy znak czy mamy go dla Ciebie przygotować?',
    tooltip:
      // eslint-disable-next-line operator-linebreak
      'Nasza oferta obejmuje przygotowanie 3 propozycji w różnych wersjach ' +
      'oraz 2-krotne poprawki.',
    form: {
      needLogo: false,
      haveLogo: false,
      logoImg: [],
    },
    disableDropzone: false,
    dropzoneOptions: {
      url: window.adminUrl || '/wp-admin/admin-ajax.php',
      autoProcessQueue: false,
      thumbnailWidth: 250,
      thumbnailHeight: 250,
      maxFilesize: 20,
      maxFiles: 3,
      addRemoveLinks: true,
      dictRemoveFile: 'Usuń plik',
      acceptedFiles: 'image/*,application/pdf',
      dictFileTooBig:
        'Plik jest za dużu {{filesize}}MB, maksymalna wielkość pliku {{maxFilesize}}MB',
      dictMaxFilesExceeded:
        'Nie możesz załączyć więcej plików (max. {{maxFiles}})',
    },
  }),
  computed: {
    showAddIcon() {
      return this.form.logoImg.length > 0 && this.form.logoImg.length < 3;
    },
  },
  validations() {
    if (this.form.haveLogo) {
      return {
        form: {
          logoImg: {
            required,
          },
        },
      };
    }
    return {
      form: {},
    };
  },
  methods: {
    logoUploaded(file) {
      this.form.logoImg.push(file);
      // this.$refs.logoDropzone.disable();
      this.disableDropzone = false;
      this.emitStep();
    },
    removedFile(file) {
      const removedUuid = file.upload && file.upload.uuid;
      this.form.logoImg = this.form.logoImg.filter((item) => {
        if (removedUuid && item.upload && item.upload.uuid) {
          return item.upload.uuid !== removedUuid;
        }
        return item !== file;
      });
      this.disableDropzone = false;
      this.$nextTick(() => {
        if (this.$v.form.logoImg) {
          this.$v.form.logoImg.$touch();
        }
        this.emitStep();
      });
    },
    updateValues() {
      this.emitStep();
    },
    onNeedLogoChange() {
      this.updateValues();

      if (this.form.needLogo) {
        window.open('https://www.solveit.pl/brief-brand/', '_blank', 'noopener,noreferrer');
      }
    },
  },
};
</script>
<style scoped lang="scss">
.brief-form {
  &__dropzone-wrapper {
    margin-bottom: rem(60px);

    &--disabled {
      pointer-events: none;
    }

    &.add {
      .vue-dropzone::v-deep {
        &::after {
          content: '';
          display: block;
          margin: rem(40px) auto 0;
          transform: translateY(-50%);
          width: rem(60px);
          height: rem(60px);
          opacity: 0.2;
          background: {
            position: center;
            repeat: no-repeat;
            size: 95%;
            image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' style='enable-background:new 0 0 512 512;' xml:space='preserve'%3E%3Cg%3E%3Cg%3E%3Cpath d='M256,0C114.833,0,0,114.833,0,256s114.833,256,256,256s256-114.853,256-256S397.167,0,256,0z M256,472.341 c-119.275,0-216.341-97.046-216.341-216.341S136.725,39.659,256,39.659S472.341,136.705,472.341,256S375.295,472.341,256,472.341z '/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3Cg%3E%3Cpath d='M355.148,234.386H275.83v-79.318c0-10.946-8.864-19.83-19.83-19.83s-19.83,8.884-19.83,19.83v79.318h-79.318 c-10.966,0-19.83,8.884-19.83,19.83s8.864,19.83,19.83,19.83h79.318v79.318c0,10.946,8.864,19.83,19.83,19.83 s19.83-8.884,19.83-19.83v-79.318h79.318c10.966,0,19.83-8.884,19.83-19.83S366.114,234.386,355.148,234.386z'/%3E%3C/g%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
          }
        }
      }
    }
  }

  &__dropzone-info::v-deep {
    color: #999;
    font-size: 0.938rem;
    font-weight: 500;
    font-style: normal;
    letter-spacing: 0.047rem;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    font-family:
      "Red Hat Display",
      -apple-system,
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Helvetica Neue",
      "Arial",
      "Noto Sans",
      sans-serif !important;

    svg {
      margin-right: rem(20px);
      width: 1.313rem;
      height: 1.5rem;
      flex-shrink: 0;
    }
  }

  .vue-dropzone::v-deep {
    min-height: rem(120px);
    padding: rem(20px);
    border: none;
    border-radius: rem(5px);
    position: relative;

    .dz-message {
      margin: rem(27px 0);
    }

    .dz-preview {
      font-family:
        "Red Hat Display",
        -apple-system,
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "Noto Sans",
        sans-serif !important;

      &:hover {
        .dz-details {
          background-color: $purple;
        }
      }

      .dz-error-message {
        top: 0px;
      }

      .dz-remove {
        border: none;
        text-transform: lowercase;
        font-weight: 500;
        text-decoration: none;

        &::after {
          content: "";
          display: block;
          width: 0;
          height: rem(1px);
          background-color: $white;
          transition: $t-width;
        }

        &:hover {
          &::after {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
